import { Quote, ShieldAlert } from "lucide-react";
import { stories } from "@/content";
import { Reveal } from "@/components/Reveal";

export default function StoriesSection() {
  return (
    <section className="section stories-section" id="depoimentos-ficcionais" data-testid="fictional-testimonials-section">
      <div className="section-shell">
        <Reveal className="stories-heading">
          <div><p className="eyebrow">SEM INVENTAR VIDAS</p><h2>Histórias compostas para você se reconhecer — não para enganar você.</h2></div>
          <div className="ethical-disclosure" data-testid="fictional-testimonials-disclaimer-box"><ShieldAlert size={18} /><p><strong>TRANSPARÊNCIA ÉTICA</strong> Estes relatos são dramatizações pedagógicas, com personagens fictícios compostos a partir de padrões de recuperação. Não são depoimentos reais, não representam pessoas específicas e não comprovam resultados.</p></div>
        </Reveal>
        <div className="stories-grid">
          {stories.map((story, index) => <Reveal key={story.name} delay={index * 80}><article className="story-item" data-testid={`fictional-story-${index + 1}`}><div className="story-meta"><span>{story.name}</span><small>{story.context}</small></div><Quote size={24} className="quote-icon" /><p className="story-struggle">{story.struggle}</p><p className="story-help">{story.help}</p><blockquote>“{story.quote}”</blockquote></article></Reveal>)}
        </div>
      </div>
    </section>
  );
}
